'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeCollection = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M13.8 5.46005C13.7 5.44005 13.6 5.43005 13.5 5.43005H5.93005C3.69005 5.43005 2.30005 7.45005 2.30005 9.32005V20.1201C2.30005 21.0501 2.79005 21.8801 3.62005 22.3401C4.03005 22.5701 4.48005 22.6801 4.94005 22.6801C5.43005 22.6801 5.91005 22.5501 6.34005 22.2901L9.71005 20.2301L13.08 22.2901C13.91 22.8001 14.95 22.8201 15.79 22.3401C16.62 21.8801 17.11 21.0501 17.11 20.1201V9.33005C17.11 7.56005 15.87 5.64005 13.8 5.45005V5.46005Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M18.3901 1.33005C18.2901 1.31005 18.1901 1.30005 18.0901 1.30005H10.5201C8.71006 1.30005 7.47006 2.63005 7.06006 4.12005H13.4601C16.2201 4.12005 18.4601 6.36005 18.4601 9.12005V18.47C19.1101 18.62 19.8001 18.55 20.4001 18.21C21.2301 17.75 21.7201 16.92 21.7201 15.99V5.21005C21.7201 3.44005 20.4801 1.52005 18.4101 1.33005H18.3901Z",
                    fill: "currentColor"
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M7.59741 5.19C7.59741 3.58 8.76676 2 10.5258 2H18.0915C18.1615 2 18.2314 2 18.2914 2.02C19.9305 2.14 20.9999 3.66 20.9999 5.2V15.99",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M3.00999 9.33001C3.00999 7.72001 4.17934 6.14001 5.93835 6.14001H13.5041C13.5741 6.14001 13.644 6.14001 13.704 6.16001C15.3431 6.28001 16.4125 7.80001 16.4125 9.34001V20.13C16.4125 21.6 14.7334 22.49 13.4441 21.71L9.70624 19.43L5.96833 21.71C4.67906 22.5 3 21.6 3 20.13V9.33001H3.00999Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

module.exports = LargeCollection;
